import { benchmarkIsActive, benchmarkIncludedInWeightedWork } from '../../../../shared/models/benchmark-policy.model';
import { Component, OnDestroy, OnInit, OnChanges, EventEmitter, Input, Output, ViewContainerRef, ViewChild, TemplateRef} from '@angular/core';
import { ReactiveFormsModule, FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import {DemoService} from '../../../../demo.service';
import {Routes, RouterModule, Router} from '@angular/router';
import {Location} from '@angular/common';
import { UserFull } from '../../../../shared/models/userFull.model';

import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HotToastService } from '@ngneat/hot-toast';

// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
 import {Observable, Subject} from 'rxjs';


// Notifications

import { DatePipe } from '@angular/common';
import { FileUploadsModalComponent } from './../../../../manager/file-uploads-modal/file-uploads-modal.component';
import {UserAvitarModalUploadComponent} from './../../../../admin/users/user-avitar-modal-upload/user-avitar-modal-upload.component';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { GlobalFunctionsService } from './../../../../services/global-functions.service';
import { ButtonComponent } from '@syncfusion/ej2-angular-buttons';
import { ColorPickerComponent, OpenEventArgs } from '@syncfusion/ej2-angular-inputs';
import { SystemAutomation } from 'src/app/shared/models/systemAutomation.model';
import { SystemLog } from 'src/app/shared/models/sysLog.model';
// import { SystemLogType } from 'src/app/shared/models/systemLogType.model';
import { SystemLogTypeDataSectorType } from 'src/app/shared/models/systemLogTypeDataSectorType.model';
import { SystemLogTypeBenchmark } from 'src/app/shared/models/systemLogTypeBenchmark.model';


@Component({
  selector: 'app-log-type-benchmark-update',
  templateUrl: './log-type-benchmark-update.component.html',
  styleUrls: ['./log-type-benchmark-update.component.scss']
})
export class LogTypeBenchmarkUpdateComponent implements OnInit, OnChanges {
  readonly benchmarkIsActive = benchmarkIsActive;
  readonly weightedIncluded = benchmarkIncludedInWeightedWork;


   // setup as observable?
 @Input() item_id?; // impliments on changes.
 @Input() item_data?; // if data.model is sent ;
 @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
 @Input() item_user_level_id? = '5'; // default to agent just in case
 @Input() item_brand_type_id? = '';
 @Input() show_buttons? = 'no'; // yes | no
 @Input() widget_title? = '';
 @Input() widget_size? = 'full'; // side | abstract | full | update_password

 allRecipients = [];
//  allAutomtaions = [];
allAutomations = [];

  // user_id: number;
  brand_user_update: any;
  user_levels: any;
  brands: any;

  @ViewChild('UserForm') form: any;
  updateBrandUserClick;

  bsModalRef: BsModalRef;
  // MODAL
  modalRef: BsModalRef;
  brand_types: any;
  brand: any;
  @Input() user_id: number;
  stripped: any;
  filenameselected: any;
  baseUploadURL: string;
  log_type_id: any;
  system_log_type: any;
  currentUserVAR: any;
  sessionUserId: any;
  sessionUserName: any;
  sessionBrandId: any;
 //Slider
  slidervalue: string;
  ticks: { placement: string; largeStep: number; smallStep: number; showSmallTicks: boolean; };

  isShow_log_insert_template = false;

// colour picker
    // @ViewChild('flatbtn')
    // public flatbtn: ButtonComponent;
    // @ViewChild("colorpicker")
    // public colorpicker: ColorPickerComponent;
    // /** Default color value is set */
    // public colorValue: string = '#0db1e7';

    // public Open(args: OpenEventArgs): void {
    //   let applyBtn = (args.element.parentElement).querySelector('.e-ctrl-btn') as HTMLElement;
    //   applyBtn.appendChild(this.flatbtn.element);
    //   this.flatbtn.element.style.display = "inline";
    // }

    // /** Reset button click function is called */
    // public resetBtnClick(): void {
    //   this.colorpicker.value = this.colorValue;
    //    /** Closing color picker popup */
    //   this.colorpicker.toggle();
    //   }
// end picker
public cValue: string = "#1de4d7";
  system_log_type_data_sectors: any;
@Input('UserForm') UserForm: any;
  system_log_levels: any;
  model: SystemLogTypeBenchmark;
  system_log_type_automations: any;
  system_log_type_data_sector_type: any;
  log_type_data_sector_type_id: number;
  @Input() log_type_benchmark_id: number;
  system_log_type_benchmark: any;
  system_log_types: any;
@Input('value')
    set value(value: any) {
        this.cValue = value;
    }



  constructor(

    private http: HttpClient,
    private _demoService: DemoService,
    private route: ActivatedRoute,
    private router:Router,
    public toastr: HotToastService,
    vcr: ViewContainerRef,
    private modalService: BsModalService,
    private _location: Location,
    public datepipe: DatePipe,
    public gfunc: GlobalFunctionsService
  ) {
    
    this.log_type_benchmark_id = +this.route.snapshot.paramMap.get('log_type_benchmark_id');
  }

  ngOnInit(): void {

    if(this.log_type_benchmark_id >= 1){
    this.model = new SystemLogTypeBenchmark
    this.getSystemLogTypeBenchmark(this.log_type_benchmark_id);
    this.getSystemLogTypes();
    this.getBrandTypes();
    this.getUserLevels();
    }
  }

  ngOnChanges(changes) {
    if (changes.item_id) {
      this.log_type_benchmark_id == changes.item_id.currentValue;

      // this.model = new SystemLogTypeBenchmark
      this.getSystemLogTypeBenchmark(this.item_id);
      this.getSystemLogTypes();
      this.getBrandTypes();
      this.getUserLevels();

    }
  }






  getSystemLogTypeBenchmark(log_type_benchmark_id) {
    this._demoService.getSystemLogTypeBenchmark(log_type_benchmark_id).subscribe(
       data => { this.system_log_type_benchmark = data;
  
        let res = data[0]
              // this.allRecipients = JSON.parse(this.system_log_type[0].system_automation_array);
              // this.allAutomations = JSON.parse(this.system_log_type[0].system_automation_array);
              // // Lookup the Automations
  
              // let new_model = {
              //   system_automation_array: JSON.parse(this.system_log_type[0].system_automation_array)
              // }
              // this.getSystemAutomationsArray(new_model);
  
      
      },
       err => console.error(err),
       () => console.log('System Log Type Data Sector Type')
     );
   }
  


   getSystemLogTypes() {
    this._demoService.getSystemLogTypes().subscribe(
       data => { this.system_log_types = data;  },
       err => console.error(err),
        () => {
          console.log('done loading System Log Types')
         // this.collection = Array (this.job_types, this.job_type_locations); // collection of all data
         // let mappedJSON = JSON.parse(mapped);
         // console.log('Mapped JSON Array: ' + mappedJSON);
        }
          );
   }



   getBrandTypes() {
    this._demoService.getBrandBrandTypes().subscribe(
       data => { this.brand_types = data; },
       err => console.error(err),
       // () => console.log('done loading candidate for update')
     );
   }



   getUserLevels() {
    this._demoService.getUserLevels().subscribe(
      data => { this.user_levels = data;
       let res = data[0];
     },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }




  setColour(value2){
    console.log('SetColour: ' + value2)
    this.UserForm.log_type_colour.value = this.UserForm.colourpicker.value
  }




  updateSystemLogTypeBenchmark(model) {

    // model.system_automation_array = this.allAutomtaions;
  
          this._demoService.updateSystemLogTypeBenchmark({...model, is_active: benchmarkIsActive(model.is_active) ? 1 : 0}).subscribe(
             data => {
              console.log(model);
               // this.trace_candidate_update = data;
             this.toastr.success('Log Type Benchmark Updated');
            //  this.gfunc.insertLog_UpdateUser(model); // hadled in the global functions file.
            //  this.gfunc.globalUserView(model.user_id);
             // Subject to reload the manager component parent.
            // BrandUserManagerComponent.returned.next(false);
               return true;
             },
             error => {
               console.error('Error saving Log Type Benchmark!');
              return console.log(error);
             }
            // err => console.error(err),
            // () => console.log('done updates')
          );
    }
  





}
